import React, { useState } from "react";

const NameChangeRequest = () => {
  const [formData, setFormData] = useState({
    currentName: "",
    newName: "",
    discordTag: "",
    reason: "",
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const webhookURL =
      "https://discord.com/api/webhooks/1375125933677084672/DYGNy4VFHmX94_Mllv6i6wahcCTpBbd6vfdkwZddCRvuTa-yR_s8gRcuHDTTJEEoTNSL";

    const embedPayload = {
      embeds: [
        {
          title: "✏️ Name Change Request",
          color: 0x3498db,
          fields: [
            { name: "Current Username", value: formData.currentName || "N/A" },
            { name: "Requested New Username", value: formData.newName || "N/A" },
            { name: "Discord Tag", value: formData.discordTag || "N/A" },
            { name: "Reason", value: formData.reason || "N/A" },
          ],
          footer: {
            text: "RixxyMC Name Change System",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const res = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embedPayload),
      });

      if (!res.ok) throw new Error("Webhook submission failed");

      setStatus({ message: "✅ Name change request submitted successfully!", type: "success" });
      setFormData({
        currentName: "",
        newName: "",
        discordTag: "",
        reason: "",
      });
    } catch (err) {
      setStatus({ message: "❌ Submission failed. Please try again later.", type: "error" });
    }
  };

  return (
    <div className="container">
      <h2>Name Change Request</h2>
      <p>Request to update your linked Minecraft username.</p>

      {status.message && (
        <div style={{ marginTop: "1rem", color: status.type === "success" ? "green" : "red" }}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="currentName">Current Minecraft Username:</label>
        <input
          type="text"
          id="currentName"
          value={formData.currentName}
          onChange={handleChange}
          placeholder="Your current Minecraft username"
          required
        />

        <label htmlFor="newName">New Minecraft Username:</label>
        <input
          type="text"
          id="newName"
          value={formData.newName}
          onChange={handleChange}
          placeholder="The new username you want to use"
          required
        />

        <label htmlFor="discordTag">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discordTag"
          value={formData.discordTag}
          onChange={handleChange}
          placeholder="Your Discord Tag"
          required
        />

        <label htmlFor="reason">Reason for Name Change:</label>
        <textarea
          id="reason"
          rows="4"
          value={formData.reason}
          onChange={handleChange}
          placeholder="Please explain why you want to change your username"
          required
        ></textarea>

        <button type="submit">Submit Request</button>
      </form>
    </div>
  );
};

export default NameChangeRequest;
